import { BsCheckCircle, BsExclamationTriangle, BsInfoCircle } from "react-icons/bs";

const TONES = {
	success: {
		wrap: "border-akgreen border-opacity-25 bg-akgreen bg-opacity-5 text-akgreenest",
		icon: BsCheckCircle,
	},
	warning: {
		wrap: "border-amber-200 bg-amber-50 text-amber-900",
		icon: BsExclamationTriangle,
	},
	info: {
		wrap: "border-gray-200 bg-gray-50 text-gray-700",
		icon: BsInfoCircle,
	},
};

const StatusBanner = ({ tone = "info", title, children, action = null, className = "" }) => {
	const config = TONES[tone] || TONES.info;
	const Icon = config.icon;

	return (
		<div
			className={`flex flex-col gap-2 rounded-lg border px-3 py-2.5 sm:flex-row sm:items-center sm:justify-between ${config.wrap} ${className}`}
			role="status"
			aria-live="polite"
		>
			<div className="flex gap-2.5">
				<Icon className="mt-0.5 h-4 w-4 flex-shrink-0 opacity-80" aria-hidden />
				<div className="min-w-0 space-y-0.5">
					{title ? <p className="text-sm font-semibold leading-snug">{title}</p> : null}
					{children ? <div className="text-sm leading-snug opacity-90">{children}</div> : null}
				</div>
			</div>
			{action ? <div className="flex-shrink-0 sm:pl-2">{action}</div> : null}
		</div>
	);
};

export default StatusBanner;
